<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <Toasts></Toasts>

      <b-row class="justify-content-center">
        <!-- Loading selector -->
        <div
          style="height: 400px; padding-top: 150px"
          v-if="loading"
          class="loading"
        >
          <b-row>
            <b-col lg="12">
              <div class="sk-double-bounce">
                <div class="sk-child sk-double-bounce1"></div>
                <div class="sk-child sk-double-bounce2"></div>
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- Loading selector END -->

        <b-col md="8" v-else>
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      v-model="username"
                      placeholder="Username"
                      autocomplete="username email"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      v-model="password"
                      placeholder="Password"
                      autocomplete="current-password"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button
                        variant="primary"
                        @click="handleLogin()"
                        class="px-4"
                        >Login</b-button
                      >
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0"
                        >Forgot password?</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card
              no-body
              class="text-white bg-primary py-5 d-md-down-none"
              style="width: 44%"
            >
              <b-card-body class="text-center justify-content-center">
                <img
                  class="navbar-brand-full"
                  src="img/brand/Vecima.jpg"
                  width="270em"
                  height="auto"
                  alt="CoreUI Logo"
                />
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import router from "../../router";
export default {
  props: ["user", "pass"],
  components: {
    router,
  },
  name: "Login",
  data: function () {
    return {
      username: "",
      loading: false,
      password: "",
    };
  },
  methods: {
    login(params) {
      this.loading = true;
      this.$http
        .get("api/" + this.$company + "/auth/login.php", { params })
        .then(
          (res) => {
            this.loading = false;
            if (res.data.status === "SUCCESS") {
              localStorage.setItem(`${this.$company}_user`, res.data.user_id);
              localStorage.setItem(
                `${this.$company}_user_picture`,
                res.data.user_picture
              );
              localStorage.setItem(
                `${this.$company}_full_name`,
                res.data.full_name
              );
              localStorage.setItem(`${this.$company}_token`, res.data.token);
              router.push("/");
            } else {
              window.location.href = process.env.VUE_APP_TRACKER_URL;
            }
          },
          (err) => {
            this.loading = false;
            console.log('cannot login', err);
            window.location.href = process.env.VUE_APP_TRACKER_URL;
          }
        );
    },
    autoLog() {
      const params = {
        user: this.user,
        pass: this.pass,
      };
      this.login(params);
    },
    handleLogin() {
      const params = {
        user: this.username,
        pass: this.password,
      };
      this.login(params);
    },
  },
  created() {
    if (this.user) {
      this.autoLog();
    } else {
      window.location.href = process.env.VUE_APP_TRACKER_URL;
    }
  },
};
</script>
